import { BUILDING_LIST, PROJECT_LIST } from '../actions/Types'

const initialState = {
    projectList: undefined,
    buildingList: undefined


}

const ProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case "PROJECT_LISTS":
            return {
                ...state,
                projectList: action.projectData
            }
        case "BUILDING_LIST":
            return {
                ...state,
                buildingList: action.buildingtData
            }
        default:
            return state;
    }
}

export default ProjectReducer